import React, { act, useMemo, useState } from "react";
import FilterCapsule from "../../components/elements/FilterCapsule";
import { filter,  } from "../../constant";
import PropertyCard from "../../components/cards/PropertyCard";

import AccommodationCard from "../../components/cards/mobileView/AccommodationCard";
import OfferCard from "../../components/cards/OfferCard";

import MobileHeader from "../../layout/MobileHeader";
import back from '../../assets/images/leftArrow.svg'
import headerImg from "../../assets/images/topLocationHeader.png";

import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../components/elements/Pagination";
import { useFetch } from "../../hooks/useFetch";
import { allAmenities, upcomingToursAndEvents } from "../../apis";
import Icon from "../../components/Icon";
import { faCalendarAlt, faLocationDot, faMinus, faPlus, faStar, faUsers } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { ObjectToParams } from "../../utils";
import TrendingCard from "../../components/cards/TrendingCard";
import ImageSlider from "../../components/elements/ImageSlider";
import { SwiperSlide } from "swiper/react";
import useWidth from "../../hooks/useWidth";



const AccommodationMobile = ({ hotelDetails = {}, locations = [], mainFilter= {}, setMainFilter = () => {} }) => {
  const width = useWidth()
  const navigate = useNavigate()
  const [ activeFilter, setActiveFilter ] = useState(null)


  const [filters, setFilters] = useState({ city: null, checkIn: null, checkOut: null, guest: null, page: null, amenities: [], priceRange:null, rating: null  })
  const [upcomingToursAndEvent] = useFetch(upcomingToursAndEvents, [])
  const [amenities] = useFetch(allAmenities, [])


  const priceRange = useMemo(() => {
    if(hotelDetails?.priceRangeCounts){
        return Object.entries(hotelDetails?.priceRangeCounts)
    }
}, [hotelDetails])

  const activeFilterContent = useMemo(() => {
    if (activeFilter === "Sort") {
      return (
        <>
          <label htmlFor={`lowToHigh`} className="d-flex align-items-center mb-1">
            <input type="checkbox" id={`lowToHigh`} checked={ mainFilter.sort == 1 } onChange={(e) => setMainFilter({ ...mainFilter, sort: e.target.checked ? 1 : null })} />
            <p className="ps-2 mb-0">Low To High</p>
          </label>

          <label htmlFor={`highToLow`} className="d-flex align-items-center mb-1">
            <input type="checkbox" id={`highToLow`} checked={ mainFilter.sort == -1 } onChange={(e) => setMainFilter({ ...mainFilter, sort: e.target.checked ? -1 : null })} />
            <p className="ps-2 mb-0">High To Low</p>
          </label>
        </>
      )
    } else if (activeFilter === "Rating") {
      return (
        [5, 4, 3, 2, 1].map(ra =>
          <label htmlFor={`rating-${ra}`} className="d-flex align-items-center mb-2" onChange={e =>  setMainFilter({ ...mainFilter, rating: e.target.checked ? ra : null })}>
            <input type="checkbox" id={`rating-${ra}`} checked={ mainFilter.rating == ra } />
            {
              Array(ra).fill(0).map(rating =>
                <Icon icon={faStar} className={"text-warning ms-2"} />
              )
            }
          </label>
        )
      )
    } else if (activeFilter === "Amenities") {
      return (
        amenities?.map((amenity, i) =>
          <label htmlFor={`amenity-${i}`} className="d-flex align-items-center mb-1">
            <input type="checkbox" id={`amenity-${i}`} onChange={(e) => e.target.checked ? setMainFilter({ ...mainFilter, amenities: [ ...mainFilter.amenities, amenity._id ]}) : setMainFilter({ ...mainFilter, amenities: mainFilter.amenities?.filter(a => a !== amenity._id )})} />
            <p className="ps-2 mb-0">{amenity.name}</p>
          </label>
        )

      )
    } else if (activeFilter === "Price") {
      return (
        priceRange?.map(([range, value], i) =>
          <div className="d-flex justify-content-between align-items-center">
            <label htmlFor={range} className="d-flex align-items-center">
              <input type="checkbox" id={range} checked={ mainFilter.priceRange == range } onChange={(e) => setMainFilter({ ...mainFilter, priceRange: e.target.checked ? range : null })}  />
              <p className="ps-2 mb-0">{range}</p>
            </label>
            <p>({value})</p>
          </div>
        )
      )
    }
  }, [ activeFilter, amenities, mainFilter ])

  return (
    <>
      <MobileHeader himage={headerImg} height="340px">
        
        <div className="px-4 w-100 pb-5">
        {/* <BookingComponent inputBackground="true" /> */}
        <div className="d-flex flex-column w-100 mb-2 gap-2">
            <div className="d-flex justify-content-center align-items-center bg-white rounded-5" style={{ padding: "5px 15px"}}>
              <Icon icon={faLocationDot} className="me-2 text-primary" />
              <input
                placeHolder={"Location"}
                value={filters.city}
                onChange={ e => setFilters({ ...filters, city: e.target.value })}
                className="form-control input-2 rounded-0 border-0 w-100"
              />
            </div>

            <div className="d-flex justify-content-center align-items-center bg-white  rounded-5" style={{ padding: "5px 15px"}}>
              <Icon icon={faCalendarAlt} className="me-2 text-primary" />
              <div className="col">
                <DatePicker 
                  placeholderText="Check In"
                  className="borderless w-100 p-1"
                  onChange={ date => setFilters({ ...filters, checkIn: date })}
                  selected={ filters.checkIn }
                />
              </div>
              <div className="col border-start border-2 ps-3">
                <DatePicker 
                  placeholderText="Check Out"
                  className="borderless w-100 p-1"
                  onChange={ date => setFilters({ ...filters, checkOut: date })}
                  selected={ filters.checkOut }
                />
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center bg-white rounded-5" style={{ padding: "5px 15px"}}>
              <Icon icon={faUsers} className="me-2 text-primary" />
              <input
                placeHolder={"No of Guest"}
                className="form-control input-2 rounded-0 border-0 w-100"
                type="number"
                onChange={ e => setFilters({ ...filters, guest: e.target.value })}
                value={ filters.guest}
              />
              <div className="d-flex">
                <span className="me-3" onClick={() => setFilters({ ...filters, guest: (+filters.guest - 1) || 0 })}><Icon icon={faMinus} /></span>
                <span onClick={() => setFilters({ ...filters, guest: (+filters.guest + 1) || 0 })}><Icon icon={faPlus} /></span>
              </div>
            </div>
        </div>

        <div className="d-flex  align-items-center ">
          <div className="bg-info me-2 rounded-circle p-1" style={{ width: "40px", height: "40px" }} onClick={() => navigate(-1)}>
            <img src={back} alt="" className="w-100" />
          </div>

          <Link to={`/search-result?${ ObjectToParams( filters )}`} className="w-25 primary-btn text-center p-1 px-0 me-5" style={{marginLeft:"25%"}}>Search</Link>
        </div>
        </div>

      </MobileHeader>

      <section style={{ marginTop: "360px" }}>
        <div className="px-4 d-flex justify-content-between align-items-end">
          <h4 className="mb-0 top-heading">{ hotelDetails?.hotels?.length } Stays Found</h4>
          <p className="mb-0 text-secondary top-destinations-subHeading">
            Price Per Room Per Night
          </p>
        </div>

        <div className=" mt-3">
          <ul className="list-unstyled d-flex gap-1 scrollbar-hidden">
            {filter.map((data, i) => (
              <li key={i} onClick={() => setActiveFilter( activeFilter === data.name ? null : data.name ) }>
                <FilterCapsule data={data} active={ data.name === activeFilter } isAppliedFilter={true} />
              </li>
            ))}
          </ul>

          { activeFilter && <div className="m-2 p-3 rounded-4 card bg-light">
            <h6>{activeFilter}:</h6>
            <div className="mt-2">
              {activeFilterContent}
            </div>
          </div>}
        </div>

        <div className="px-3 mt-5">
          <ul className="list-unstyled">
            {hotelDetails?.hotels?.map((property, i) => (
              <li key={i} className="mb-3 p-0">
                <PropertyCard data={property} imageSlide />
              </li>
            ))}
          </ul>
        </div>

        <div className="w-100 my-2 d-flex justify-content-center align-items-center px-5">
          <Pagination pages={hotelDetails.totalPages} currentPage={hotelDetails.currentPage} onPageChange={ page => (console.log('page', page), setFilters({ ...filters, page }))}  />
        </div>
      </section>
      <hr />
      {/* top locations */}
      <section>
        <div className="row mx-0">
          <div className="col-md-8 p-3">
            <div className="top-heading">Upcoming tours & events</div>
            <div className="top-destinations-subHeading mt-2">
              Making the Most of Your Travel Experience in 2024
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-end">
            <div className="view-all w-50">Know More</div>
          </div>

          {/* <div className="mt-4 p-0">
            <ul className="list-unstyled d-flex overflow-auto scrollbar-hidden">
              {Location.map((location, i) => (
                <li className="m-2" key={i}>
                  <div className="location-card-container">
                    <LocationCard data={location} />
                  </div>
                </li>
              ))}
            </ul>
          </div> */}

          <div className='overflow-auto scrollbar-hidden my-3'>
            <div className="d-flex ">

              <ImageSlider slidesPerView={Math.fround(width / (width > 992 ? 950 : 420)).toFixed(1)}>
                {
                  upcomingToursAndEvent?.map((tour, i) =>
                    <div className='col-lg-8 col-md-12' >
                      <SwiperSlide>
                        <TrendingCard data={tour} />
                      </SwiperSlide>
                    </div>
                  )
                }
              </ImageSlider>
            </div>
          </div>
      </div>
        <div className="d-flex justify-content-center align-item-center">
          <Link to={'/tours-events'} className="secondary-btn"> Explore more </Link>
        </div>
      </section>
      <hr />
      <section>
        <div className="px-3 my-4">
          <div className="top-heading">Location based Accommodation </div>

          <div className="mt-4 p-0">
            <ul className="list-unstyled d-flex overflow-auto scrollbar-hidden">
              {locations.map((location, i) => (
                  <li className="m-2" key={i}>
                    <div
                      className=""
                      style={{ width: "230px", height: "240px" }}
                    >
                      <AccommodationCard data={location} />
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </section>

      {/* offers */}
      <section>
        <div className="offers my-3 px-3">
          <div className="top-heading"> Best Offers for You</div>

          <div className="  mx-0 my-2 ">
            <ul className="list-unstyled  d-flex offers-card-list-mobile  mobileScrollBar">
              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Get upto 15% off on your First Booking"} />
                </div>
              </li>

              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Budget Friendly Homestays"} />
                </div>
              </li>
            </ul>

            </div>
        </div>
      </section>
    </>
  );
};

export default AccommodationMobile;
